import request from '@/utils/request'

// 导入用户

let ImportUserApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.import_user/index', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.import_user/del', data, errorback);
    },

    /*编辑*/
    add(data, errorback) {
        return request._post('/shop/study.import_user/add', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.import_user/edit', data, errorback);
    }
}

export default ImportUserApi;



// WEBPACK FOOTER //
// ./src/api/study/import_user.js